module.exports = __webpack_public_path__ + "img/turkey.1554b9ec.svg";